import { SurveyActions } from './../action/SurveyActions';
import { SurveyState, initialState } from './../state/SurveyState';
import { SurveyActionTypes } from '../action';

export function surveyReducer(state: SurveyState = initialState, action: SurveyActions): SurveyState {
    switch (action.type) {
        case SurveyActionTypes.SURVEY_SAVE:
            return {...state, loadingSurvey: true, errorSurvey: false, currentSurvey: action.surveyData, currentAnswers: null, currentDemographicAnswers: null };
        case SurveyActionTypes.SURVEY_SAVE_SUCCESS:
            return {...state, loadingSurvey: false, errorSurvey: false, currentSurvey: action.surveyData };
        case SurveyActionTypes.SURVEY_SAVE_ERROR:
            return {...state, loadingSurvey: false, errorSurvey: true, currentSurvey: null };
        case SurveyActionTypes.SURVEY_CLEAR:
            return {...state, loadingSurvey: false, errorSurvey: false, currentSurvey: null, currentAnswers: null, currentDemographicAnswers: null };
        case SurveyActionTypes.SURVEY_LOAD_ANSWER:
            return {...state, loadingAnswer: true, errorAnswer: false, currentAnswers: null };
        case SurveyActionTypes.SURVEY_LOAD_ANSWER_SUCCESS:
            return {...state, loadingAnswer: false, errorAnswer: false, currentAnswers: action.answerData };
        case SurveyActionTypes.SURVEY_LOAD_ANSWER_ERROR:
            return {...state, loadingAnswer: false, errorAnswer: true, currentAnswers: null };
        case SurveyActionTypes.SURVEY_LOAD_DEMOGRAPHIC_ANSWER:
            return {...state, loadingDemographicAnswer: true, errorDemographicAnswer: false, currentDemographicAnswers: null };
        case SurveyActionTypes.SURVEY_LOAD_DEMOGRAPHIC_ANSWER_SUCCESS:
            return {...state, loadingDemographicAnswer: false, errorDemographicAnswer: false, currentDemographicAnswers: action.answerDemographicData };
        case SurveyActionTypes.SURVEY_LOAD_DEMOGRAPHIC_ANSWER_ERROR:
            return {...state, loadingDemographicAnswer: false, errorDemographicAnswer: true, currentDemographicAnswers: null };
        case SurveyActionTypes.SURVEY_SAVE_ANSWER:
            return {...state, loadingSaveAnswer: true, errorSaveAnswer: false };
        case SurveyActionTypes.SURVEY_SAVE_ANSWER_SUCCESS:
            return {...state, loadingSaveAnswer: false, errorSaveAnswer: false, currentAnswers: action.answerData };
        case SurveyActionTypes.SURVEY_SAVE_ANSWER_ERROR:
            return {...state, loadingSaveAnswer: false, errorSaveAnswer: true };
        case SurveyActionTypes.SURVEY_SAVE_DEMOGRAPHIC_ANSWER:
            return {...state, loadingSaveDemographicAnswer: true, errorSaveDemographicAnswer: false };
        case SurveyActionTypes.SURVEY_SAVE_DEMOGRAPHIC_ANSWER_SUCCESS:
            return {...state, loadingSaveDemographicAnswer: false, errorSaveDemographicAnswer: false, currentDemographicAnswers: action.answerDemographicData };
        case SurveyActionTypes.SURVEY_SAVE_DEMOGRAPHIC_ANSWER_ERROR:
            return {...state, loadingSaveDemographicAnswer: false, errorSaveDemographicAnswer: true };
        case SurveyActionTypes.SURVEY_CLEAR_ERRORS:
            return {...state, 
                loadingTeam: false,
                errorTeam: false,
                loadingOrganization: false,
                errorOrganization: false,
                loadingSurvey: false,
                errorSurvey: false,
                loadingAnswer: false,
                errorAnswer: false,
                loadingDemographicAnswer: false,
                errorDemographicAnswer: false,
                loadingSaveAnswer: false,
                errorSaveAnswer: false,
                loadingSaveDemographicAnswer: false,
                errorSaveDemographicAnswer: false
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducer/SurveyReducer.ts